import AbstractValidator from './abstractValidator';

/**
 * @class ItemVersionValidator
 * @extends AbstractValidator
 */
export default class ItemVersionValidator extends AbstractValidator {
    /**
     * @param {ProblemFactory} problemFactory
     * @param {ProductFamilyStore} productFamilyStore
     * @param {string} message
     */
    constructor(problemFactory, productFamilyStore, message) {
        super(problemFactory);

        this.message = message;
        this.productFamilyStore = productFamilyStore;
    }

    _isItemSupported(item) {
        return item.supportsVersions;
    }

    _isItemValid(item) {
        const itemId = item.get('itemId');
        const itemSize = item.get('size');
        const accessory = item.get('accessory');
        const alignment = item.get('align');
        const currentVersion = item.get('version');
        const family = this.productFamilyStore.getByItemId(itemId);
        const versions = family.variants[itemSize][accessory][alignment];
        // TODO: use productFamilyStore method to get versions

        return !Object.keys(versions).find(versionNumber => currentVersion < versionNumber.split('_')[0]);
    }

    _createProblems(item) {
        return [this.problemFactory.createVersionWarning('itemVersion', this.message, 'bookmark', [item])];
    }
}
